module.exports = __webpack_public_path__ + "img/b3.3acee075.webp";